__turbopack_context__.v({
  "appear": "placement-reveal-module-scss-module__oUn7oG__appear",
  "hold": "placement-reveal-module-scss-module__oUn7oG__hold",
  "placementAppear": "placement-reveal-module-scss-module__oUn7oG__placementAppear",
  "placementStepProgress": "placement-reveal-module-scss-module__oUn7oG__placementStepProgress",
  "stepProgress": "placement-reveal-module-scss-module__oUn7oG__stepProgress",
});
